import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/dholpur.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from "react-helmet";

const Dholpur = () => {
  return (
    <>
    <Helmet>
  <title>Dholpur: Unveiling Rajasthan's Turbulent History & Enchanting Diversity</title>

  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta name="description" content="Discover Dholpur, a city steeped in history and resilience, situated at the crossroads of Kabul and Delhi's ancient route. Immerse yourself in Dholpur's rich past, from battles fought during Mughal reigns to the resilience shown by its brave rulers. Explore historic sites like Shergarh Fort, Khanpur Mahal, the revered Shiva Temple, and the scenic Ramsagar Sanctuary. Delight in nature's bounty at Talab Shahi and Ramsagar Sanctuary, home to diverse aquatic and avian life. Wander through historic locales like Rana Kumbha's Palace and Nagari, where Hindu/Buddhist remains from ancient times abound. Embark on a spiritual journey to Matri Kundia Temple, Sanwariyaji Temple, and the legendary Sita Mata Sanctuary, entwined with tales from the Ramayana. Experience the wildlife diversity at Bassi Wildlife Sanctuary and Van Vihar, offering a glimpse into Rajasthan's natural wonders. Discover the untold tales and natural splendor of Dholpur, a trove of heritage and biodiversity." />

  <meta name="keywords" content="Dholpur, Rajasthan, history, resilience, Mughal reigns, Shergarh Fort, Khanpur Mahal, Shiva Temple, Ramsagar Sanctuary, Talab Shahi, Rana Kumbha's Palace, Nagari, Hindu/Buddhist remains, Matri Kundia Temple, Sanwariyaji Temple, Sita Mata Sanctuary, Bassi Wildlife Sanctuary, Van Vihar, wildlife, heritage, biodiversity" />

  <meta name="author" content="The Rustic Paths" />

  <meta property="og:title" content="Dholpur: Unveiling Rajasthan's Turbulent History & Enchanting Diversity" />
  <meta property="og:description" content="Discover Dholpur, a city steeped in history and resilience, situated at the crossroads of Kabul and Delhi's ancient route. Immerse yourself in Dholpur's rich past... (trimmed for brevity)" />
  <meta property="og:image" content={tour1} />

</Helmet>

      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">Dholpur</h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Laswari</li>
                      <li>Shergarh Fort</li>
                      <li>The Khanpur Mahal</li>
                      <li>The Shiva Temple</li>
                      <li>Muchchhkund</li>
                      <li>Ramsagar Sanctuary</li>
                      <li>Talab Shahi</li>
                      <li>Van Vihar Wild Life Sanctuary</li>
                      <li>Rana Kumbha's Palace</li>
                      <li>Bassi Village</li>
                      <li>Bassi Wildlife Sanctuary</li>
                      <li>Bijalpur</li>
                      <li>Matri Kundia Temple</li>
                      <li>Nagari</li>
                      <li>Sanwariyaji Temple</li>
                      <li>Sita Mata Sanctuary</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Dholpur
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Formerly known as Dhawalpuri, the city of Dholpur boasts of
                    a rich history that fascinates every visitor. It was
                    established by a small time ruler named Dhawal Deo who named
                    the city after himself. Dholpur was a relatively small
                    kingdom but had a very turbulent history, the reason being
                    its strategic location on the main route linking Kabul to
                    Delhi. Besides, its proximity to some powerful cities like
                    Gwalior, Agra and Bayana attracted many rulers who wished to
                    take advantage of its strategic location. The brave rulers
                    of Dholpur always did their best to resist every attempt to
                    subjugate them, however, the city regularly suffered at the
                    hands of the invading forces. From Sikander Lodi in 1501 AD
                    to Babur in 1526 AD, Dholpur was repeatedly attacked by
                    neighboring kings and was almost razed to the ground. During
                    Humayun's rule, the site of Dholpur town was moved
                    northwards to avoid erosion by the river Chambal. Two
                    important Mughal wars were fought near Dholpur, the first
                    being the one when Aurangzeb defeated his brother Dara Sikoh
                    in 1658. The second was a war of succession fought between
                    Aurangzeb's sons in 1707 AD.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Laswari
                  </h2>

                  <p>
                    It is the very site where Daulat Rao Scindia was defeated by
                    Lord Lake. The ruins of the oldest Mughal garden, the Damoh
                    Waterfall and the Kanpur Mahal are the main attractions of
                    Laswari.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Shergarh Fort
                  </h2>
                  <p>
                    Located towards the south of Dholpur, the Shergarh Fort was
                    built by Sher Shah Suri on the ruins of a Hindu fortress.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    The Khanpur Mahal
                  </h2>
                  <p>
                    This exquisite structure was meant to be a pleasure- palace
                    for Mughal Emperor Shah Jahan
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    The Shiva Temple
                  </h2>
                  <p>
                    This ancient temple boasts of great architectural beauty and
                    importance and is located near the Gwalior- Agra road.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Muchchhkund
                  </h2>
                  <p>
                    Located 8 kms away from Dholpur, Muchchhkund is a revered
                    Hindu site. It was named after Raja Muchchhkund the 24th
                    king of the Suryavanshi Dynasty (the solar race) who is
                    believed to have reigned nineteen generations before Lord
                    Ram.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Ramsagar Sanctuary
                  </h2>
                  <p>
                    The sanctuary is located some 34 kms away from Dholpur and
                    boasts of a rich aquatic life that includes freshwater
                    crocodiles besides a variety of fishes and snakes. Visitors
                    can also have a look at many water birds like Cormorants,
                    Jacanas, River Terns, Moor Hens, Ringed Plovers and Stilts.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Talab Shahi
                  </h2>
                  <p>
                    This beautiful lake is situated beside a hunting lodge built
                    for Shah Jahan in 1617 AD. Situated 40 km away from Dholpur,
                    the lake attracts a large number of winter migratory fowls
                    like the Pintail, Shoveller, Red Crested Pochard, Comnion
                    Pochard, Tufted Duck, Common Teal, Garganey Teal and
                    Gadwall.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Van Vihar Wild Life Sanctuary
                  </h2>
                  <p>
                    This old wildlife reserve of the rulers of Dholpur is
                    located around 18 kms away from Dholpur. Spread over an area
                    of 59.86. Sq. kms, the reserve boasts of a rich wildlife.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Rana Kumbha's Palace
                  </h2>
                  <p>
                    The ruined palace is believed to have underground cellars
                    where Rani Padmini and other women committed the act of
                    'Jauhar'.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bassi Village
                  </h2>
                  <p>
                    Located 25 kms away from Chittorgarh, the Bassi Village is
                    known for its forts, temples, woodworks and sculptures.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bassi Wildlife Sanctuary
                  </h2>
                  <p>
                    The sanctuary is home to panthers, wild boars, antelopes and
                    migratory birds. However, prior permission must be obtained
                    from the District Forest Office of Chittorgarh before
                    visiting the sanctuary.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bijalpur
                  </h2>
                  <p>
                    This grand castle is at a distance of 40 kms away from
                    Chittorgarh. It was built by Rao Shakti Singh and has now
                    been converted into a heritage hotel.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Matri Kundia Temple
                  </h2>
                  <p>
                    Known as the 'Haridwar of Mewar,' this temple is dedicated
                    to Lord Shiva.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Nagari
                  </h2>
                  <p>
                    Located 20 kms away from Chittorgarh, Nagari is one of the
                    oldest towns of Rajasthan. Many Hindu / Buddhist remains of
                    the Mauryan and Gupta period can be seen here today.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Sanwariyaji Temple
                  </h2>
                  <p>
                  This temple is dedicated to Lord Krishna and is a popular pilgrimage spot.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Sita Mata Sanctuary
                  </h2>
                  <p>
                  This sanctuary sprawls over the Aravalli ranges and the Malawi plateau with three rivers flowing through it. Legend has it that Sita, wife of Lord Rama stayed in a hermitage located within this jungle after she was exiled by her husband. The animal populace is represented by the Leopard, Hyena, Jungle Fox, Porcupine, Sambhar, Wild Bear, four-horned Antelope and Nilgai.

                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Dholpur;
